<div id="leftButtons" class="flex items-center">
            
    <!-- BACK -->
    <app-back-button/>
    
    <!-- MOBILE MENU BUTTON -->
    @if(isMobile()){

        <app-mobile-button/>

    }

    <!-- SEARCH -->
    @else {

        <app-search/>
        
        <!-- HOME -->
        <app-home-button/>

    }

</div>